import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/ai-model-cards": [~5,[2]],
		"/ai-model-cards/[model]": [~6,[2]],
		"/faq": [7],
		"/faq/services": [8],
		"/news": [~9],
		"/quickstart": [10],
		"/syntax": [11],
		"/tools": [12,[3]],
		"/tools/builder": [~13,[3]],
		"/tools/validator": [~14,[3]],
		"/use-cases": [15]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.js';